<template>
  <div class="address-data">
    <h4 class="address-data__title title">Endereço</h4>
    <form class="address-data__form grid form" @submit.prevent="handleSubmit">
      <label class="address-data__country form__label form__label--select form__group--column">
        <span class="form__label-text form__label-text--fullfiled">País de residência</span>
        <select
          class="form__input"
          name="country"
          v-model="address.country"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        >
          <optgroup
            v-for="continent in countriesList"
            :label="continent.continent"
            :key="`${continent.continent}`"
          >
            <option
              v-for="country in continent.countries"
              :key="`${continent}_${country}`"
              :value="country"
            >{{ country }}</option>
          </optgroup>
        </select>
        <span class="form__error-message"></span>
      </label>
      <label class="address-data__zipCode form__label form__group--column">
        <span class="form__label-text">CEP</span>
        <input
          class="form__input"
          type="tel"
          name="zipCode"
          v-model="address.zipCode"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        />
        <span class="form__error-message"></span>
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__times: validation.zipCode === false,
              icon__check : validation.zipCode
            }"
          />
        </span>
      </label>
      <label class="address-data__neighborhood form__label form__group--column">
        <span class="form__label-text">Bairro</span>
        <input
          class="form__input"
          type="text"
          name="neighborhood"
          v-model="address.neighborhood"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        />
        <span class="form__error-message"></span>
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__times: validation.neighborhood === false,
              icon__check : validation.neighborhood
            }"
          />
        </span>
      </label>
      <label class="address-data__street form__label form__group--column">
        <span class="form__label-text">Logradouro</span>
        <input
          class="form__input"
          type="text"
          name="street"
          v-model="address.street"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        />
        <span class="form__error-message"></span>
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__times: validation.street === false,
              icon__check : validation.street
            }"
          />
        </span>
      </label>
      <label class="address-data__number form__label form__group--column">
        <span class="form__label-text">Número</span>
        <input
          class="form__input"
          type="number"
          name="number"
          v-model="address.number"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        />
        <span class="form__error-message"></span>
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__times: validation.number === false,
              icon__check : validation.number
            }"
          />
        </span>
      </label>
      <label class="address-data__complement form__label form__group--column">
        <span class="form__label-text">Complemento</span>
        <input
          class="form__input"
          type="text"
          name="complement"
          v-model="address.complement"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
        />
        <span class="form__error-message"></span>
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__check : validation.complement
            }"
          />
        </span>
      </label>
      <label class="address-data__city form__label form__group--column">
        <span class="form__label-text">Cidade</span>
        <input
          class="form__input"
          type="text"
          name="city"
          v-model="address.city"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        />
        <span class="form__error-message"></span>
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__times: validation.city === false,
              icon__check : validation.city
            }"
          />
        </span>
      </label>
      <label class="address-data__state form__label form__group--column">
        <span class="form__label-text">Estado</span>
        <input
          class="form__input"
          name="state"
          v-model="address.state"
          @focus="handleFocus"
          @input="handleInput"
          @blur="handleBlur"
          required="required"
        />
        <span class="form__error-message"></span>
        <span class="form__validation">
          <i
            class="icon"
            :class="{
              icon__times: validation.state === false,
              icon__check : validation.state
            }"
          />
        </span>
      </label>
      <button aria-label="Botão para seguir em frente no preenchimento do formulário" type="submit" class="address-data__submit form__submit">
        continuar
        <i class="icon__go-ahead" />
      </button>
    </form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import countriesList from "../../assets/helpers/countriesList";
import axios from "axios";
export default {
  name: "AddressDataForm",
  data() {
    return {
      address: {
        country: "Brasil",
        zipCode: null,
        neighborhood: "",
        street: "",
        number: null,
        complement: "",
        city: "",
        state: ""
      },
      countriesList,
      validation: {
        zipCode: null,
        neighborhood: null,
        street: null,
        number: null,
        complement: null,
        city: null,
        state: null
      }
    };
  },
  computed: {
    ...mapState(["quotation"])
  },
  methods: {
    ...mapActions([
      "setUserState",
      "setLocalSave",
      "setQuotationStepIncrement",
      "setQuotationState"
    ]),
    handleUserState(event) {
      const payload = {
        event,
        group: "addressData"
      };
      this.setUserState(payload);
      this.setLocalSave({
        storeItemName: "user",
        storeItemObject: this.quotation.user
      })
    },
    handleFocus: function({ target }) {
      const { previousElementSibling, type } = target;
      if (type !== "checkbox" && type !== "radio") {
        previousElementSibling.classList.add("form__label-text--focus");
      }
    },
    handleInput: function(event) {
      const {
        target: {
          parentElement,
          previousElementSibling,
          nextElementSibling,
          type,
          validity: { valid }
        }
      } = event;
      if (type !== "checkbox" && type !== "radio") {
        previousElementSibling.classList.add("form__label-text--fullfiled");
        if (valid) {
          parentElement.classList.remove("error");
          nextElementSibling.innerText = "";
        }
      }
    },
    handleBlur: function(event) {
      const {
        target: {
          name,
          parentElement,
          previousElementSibling,
          nextElementSibling,
          validity: { valid, valueMissing }
        }
      } = event;
      previousElementSibling.classList.remove("form__label-text--focus");
      if (!valid) {
        this.validation[name] = false;

        if (valueMissing) {
          nextElementSibling.innerText = "Campo obrigatório";
        }
        parentElement.classList.add("error");
      } else {
        if (name === "zipCode" && !valueMissing) {
          if (this.address.country === "Brasil") {
            axios
              .get(
                `https://viacep.com.br/ws/${this.address.zipCode.replace(
                  /\D/g,
                  ""
                )}/json/`
              )
              .then(res => {
                if(res.data.logradouro) {
                  const { bairro, localidade, logradouro, uf } = res.data;
                  // Setting input values
                  this.address.neighborhood = document.querySelector(
                    ".address-data__neighborhood .form__input"
                  ).value = bairro;
                  this.address.street = document.querySelector(
                    ".address-data__street .form__input"
                  ).value = logradouro;
                  this.address.city = document.querySelector(
                    ".address-data__city .form__input"
                  ).value = localidade;
                  this.address.state = document.querySelector(
                    ".address-data__state .form__input"
                  ).value = uf;
                  // UI interection
                  document
                    .querySelector(".address-data__country .form__label-text")
                    .classList.add("form__label-text--fullfiled");
                  document
                    .querySelector(
                      ".address-data__neighborhood .form__label-text"
                    )
                    .classList.add("form__label-text--fullfiled");
                  document
                    .querySelector(".address-data__street .form__label-text")
                    .classList.add("form__label-text--fullfiled");
                  document
                    .querySelector(".address-data__city .form__label-text")
                    .classList.add("form__label-text--fullfiled");
                  document
                    .querySelector(".address-data__state .form__label-text")
                    .classList.add("form__label-text--fullfiled");
                  // Helping UX
                  document
                    .querySelector(".address-data__neighborhood .form__input")
                    .focus();
                  document
                    .querySelector(".address-data__street .form__input")
                    .focus();
                  document
                    .querySelector(".address-data__city .form__input")
                    .focus();
                  document
                    .querySelector(".address-data__state .form__input")
                    .focus();
                  document
                    .querySelector(".address-data__number .form__input")
                    .focus();
                }
              });
          }
        }
        if (valueMissing) {
          previousElementSibling.classList.remove(
            "form__label-text--fullfiled"
          );
        } else {
          this.handleUserState(event);
          this.validation[name] = true;
        }
      }
    },
    handleSubmit: function() {
      this.$router.push("/cotacao/dados-financeiros");
      this.setQuotationStepIncrement();
    }
  },
  mounted() {
    if (localStorage.user) {
      const { addressData } = JSON.parse(localStorage.user);

      for (let field in addressData) {
        this.address[field] = addressData[field];

        const inputRendered = document.querySelector(`[name=${field}]`);

        if (
          inputRendered.type !== "radio" &&
          inputRendered.type !== "checkbox"
        ) {
          inputRendered.previousElementSibling.classList.add(
            "form__label-text--fullfiled"
          );
        }
      }
    }
  }
};
</script>

<style lang="scss">
.address-data {
  @include fade-in();
  animation-delay: 0.2s;

  &__title {
    margin-bottom: $space__lg;
  }

  &__subtitle {
    grid-area: subtitle;
  }

  &__form {
    grid-template-areas:
      "country country country"
      "zipCode neighborhood neighborhood"
      "street street street"
      "number complement complement"
      "city city state"
      "submit submit submit";

    @include breakpoint($tablet__min--sm) {
      grid-template-areas:
        "country zipCode neighborhood"
        "street number complement"
        "city state ."
        ". submit .";
    }

    @include breakpoint($desk__min--sm) {
      grid-template-areas:
        "country zipCode neighborhood street number"
        "complement city state . ."
        ". . submit . .";
    }
  }

  &__country {
    grid-area: country;
  }

  &__zipCode {
    grid-area: zipCode;
  }

  &__neighborhood {
    grid-area: neighborhood;
  }

  &__street {
    grid-area: street;
  }

  &__number {
    grid-area: number;
  }

  &__complement {
    grid-area: complement;
  }

  &__citY {
    grid-area: city;
  }

  &__state {
    grid-area: state;
  }

  &__submit {
    position: relative;
    grid-area: submit;

    .icon__go-ahead {
      position: absolute;
      top: 50%;
      right: $space__st;
      transform: translateY(-50%);
    }
  }
}
</style>
